import React from 'react';
import { Card, CardContent, Stack, Typography } from '@mui/material';
import AddIcon from '@mui/icons-material/Add';

import { BaseComponent } from '../Component';
import { theme as evoachDefaultTheme } from '../../theme/theme';
import { CardImageSize, CardSize } from '../ObjectCard';

export interface ObjectAddCardHorizontalComponent extends BaseComponent {
  type: 'objectAddCard';
  props: ObjectAddCardHorizontalProps;
}
export interface ObjectAddCardHorizontalProps {
  label: string;
  onClick?: Function;
  cardSize?: CardSize;
}
export const ObjectAddCardHorizontal: React.FC<ObjectAddCardHorizontalProps> = ({
  label,
  onClick,
  cardSize = CardSize.LARGE,
}) => {
  const baseWidth = cardSize * 1.8;
  // const descriptionWidth = cardSize === CardSize.LARGE ? 110 : 55;
  const width = baseWidth - 145 + CardImageSize.MINI + 'px';

  let height = cardSize === CardSize.LARGE ? '255px' : '200px';
  switch (cardSize) {
    case CardSize.LARGE:
      height = '255px';
      break;
    case CardSize.SMALL:
      height = '200px';
      break;
    case CardSize.MINI:
      height = '130px';
      break;
  }

  return (
    <Card
      sx={{
        width: width,
        maxWidth: width,
        height: height,
        maxHeight: height,
        overflow: 'hidden',
        cursor: 'pointer',
        marginBottom: '1rem',
        display: 'flex',
        borderRadius: 3,
        backgroundColor: 'white',
      }}
      raised
      onClick={() => {
        if (onClick) {
          onClick();
        }
      }}
    >
      <CardContent style={{ display: 'flex', flex: 1 }}>
        <Stack
          direction="column"
          alignItems="center"
          justifyContent="center"
          width="100%"
          style={{
            overflow: 'hidden',
          }}
        >
          <div
            style={{
              alignItems: 'center',
              color: evoachDefaultTheme.palette.secondary.main,
              fontSize: '70px',
              justifyContent: 'center',
              display: 'flex',
              flex: 1,
            }}
          >
            <AddIcon fontSize="inherit" color="inherit" />
          </div>
          <div style={{ alignItems: 'center', paddingLeft: '10px' }}>
            <Typography
              variant="body2"
              color={evoachDefaultTheme.palette.secondary.main}
              component="div"
              fontWeight={500}
            >
              {label}
            </Typography>
          </div>
        </Stack>
      </CardContent>
    </Card>
  );
};
